import styled from 'styled-components';

const Column = styled.div`
  width: ${({ theme }) => theme.formColumnWidth};
`;

export default Column;
